import * as React from "react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { storeJsonSelector } from "../selector";
import { useAppSelector } from "../store";
import { generateShareableUrl } from "../utils";
import FullCenteredRow from "./FullCenteredRow";

export default function SaveButton() {
  const stateJson = useSelector(storeJsonSelector);
  const state = useAppSelector((state) => state);
  const [saved, setSaved] = useState<string | null>(
    localStorage.getItem("data")
  );
  const [linkCopied, setLinkCopied] = useState<boolean>(false);

  function save() {
    localStorage.setItem("data", stateJson);
    setSaved(stateJson);
  }

  async function copyLink() {
    try {
      const shareableUrl = generateShareableUrl(state);
      await navigator.clipboard.writeText(shareableUrl);
      setLinkCopied(true);
      // Reset the "copied" state after 3 seconds
      setTimeout(() => setLinkCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy link: ', err);
    }
  }

  return (
    <FullCenteredRow>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
        <button
          type="button"
          className="btn btn-primary"
          disabled={saved === stateJson}
          onClick={save}
        >
          <FormattedMessage id="Common.Save" />
        </button>
        <button
          type="button"
          className={`btn ${linkCopied ? 'btn-success' : 'btn-secondary'}`}
          onClick={copyLink}
          title={linkCopied ? undefined : "Copy shareable link with current values"}
        >
          {linkCopied ? (
            <>
              ✓ <FormattedMessage id="Common.LinkCopied" />
            </>
          ) : (
            <>
              🔗 <FormattedMessage id="Common.Copy" />
            </>
          )}
        </button>
      </div>
    </FullCenteredRow>
  );
}
